import { cameraDown, cameraWorking, exitMaintenance } from '../../../actions/maintenanceActions';

export default function ImagingDeviceHandler(store, status){
  if(status.ImagingDevice.HardwareResult === 0){        //No errors
    if(!store.getState().maintenance.cameraWorking)     //if we have the state set in camera down
        store.dispatch(cameraWorking())                 //Change to working
  }
  else if(status.ImagingDevice.HardwareResult > 0){     //There are errors

    //we ignore this ones
    if(store.getState().maintenance.active || store.getState().router.location.pathname === '/maintenance-mode' || store.getState().router.location.pathname === '/enter_serial' || store.getState().router.location.pathname === '/pre-ok'){          //Check if we are in a maintenance mode
      store.dispatch(exitMaintenance());              //Turn off maintenance mode
    }

    if(store.getState().maintenance.cameraWorking)      //If we have the state set in camera working
      store.dispatch(cameraDown())                      //Change to down
  }
  else
    console.error('STATUS NOT REGISTERED')
}